import styled from 'styled-components';

export const RewardContainer = styled.div`
    /* padding: 15px; */
`

export const RewardCard = styled.div`
    display: flex;
    flex-direction: column;
    margin: 15px;
    padding: 15px;
    background-color: ${({theme}) => theme.colors.primary};
    border: 1px solid ${({theme}) => theme.colors.link.text};
`